(()=>{
let observer=null, main=null, bar=null, frame=0;
function update(){if(!bar||!main)return;const r=main.getBoundingClientRect();bar.hidden=!(r.bottom<=0&&main.isConnected);}
function schedule(){if(frame)return;frame=requestAnimationFrame(()=>{frame=0;update();});}
window.addEventListener("scroll",schedule,{passive:true});
window.addEventListener("resize",schedule,{passive:true});
function connect(){
 const nextBar=document.querySelector('#app .sticky-buy');
 const nextMain=document.querySelector('#app .product-info .atc-main');
 if(nextBar===bar && nextMain===main)return;
 observer?.disconnect();bar=nextBar;main=nextMain;
 if(!bar||!main)return;
 bar.hidden=true;
 observer=new IntersectionObserver(update,{threshold:[0,1]});observer.observe(main);update();
}
const app=document.getElementById('app');
if(app)new MutationObserver(connect).observe(app,{childList:true,subtree:true});
connect();
})();
